// utils_localStorage.js  (ESM)
const isBrowser =
  typeof window !== "undefined" &&
  typeof window.localStorage !== "undefined";

const memory = new Map();

export function getItem(key) {
  try {
    if (isBrowser) return window.localStorage.getItem(key);
    return memory.has(key) ? memory.get(key) : null;
  } catch {
    return null;
  }
}

export function setItem(key, value) {
  try {
    if (isBrowser) window.localStorage.setItem(key, value);
    else memory.set(key, String(value));
  } catch {}
}

export default { getItem, setItem };
